export const Features = {
  UseSseForAnswers: 'use-sse-for-answers',
  HistoryTab: 'enableHistoryTab',
} as const;
